//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
import HiHeader from "../../components/header/Index.vue";
import HiButton from "../../components/button/Index.vue";
import HiCell from "../../components/cell/Index.vue";
import UnlimitedAutoPost from "../../components/plan/unlimited_autopost_list/Index.vue";
import Email from "../../components/plan/email/Index.vue";
import LinkInstagram from "../../components/plan/added_instagram/Index.vue";
import Type from "../../components/plan/type/Index.vue";
import Upgrade from "../../components/plan/upgrade/Index";
import TeamMember from "../../components/plan/team_member/Index.vue";
import { updateUserInfo } from "../../services/users";
import { mapGetters } from "vuex";
import {
  CURRENT_USER_INFO_SIMPLE,
  CURRENT_PUBLISHER_SIMPLE,
} from "../../store/mutation-types";
import { clear } from "../../store";
import { showErrorMsg } from "../../utils/error";
import { list as planList } from "../../services/plans";

export default {
  name: "MyPlanPage",
  components: {
    HiHeader,
    HiButton,
    HiCell,
    UnlimitedAutoPost,
    Email,
    LinkInstagram,
    Type,
    TeamMember,
    Upgrade,
  },
  async activated() {
    try {
      await updateUserInfo({});
    } catch (e) {
      console.log(e);
      showErrorMsg(e);
    }
  },
  mounted() {
    async function checkStatus() {
      const clientSecret = new URLSearchParams(window.location.search).get(
        "payment_intent_client_secret"
      );

      if (!clientSecret) {
        return;
      }

      const { paymentIntent } = await this.$stripe.retrievePaymentIntent(
        clientSecret
      );

      console.log(paymentIntent);
      // switch (paymentIntent.status) {
      //   case "succeeded":
      //     showMessage("Payment succeeded!");
      //     break;
      //   case "processing":
      //     showMessage("Your payment is processing.");
      //     break;
      //   case "requires_payment_method":
      //     showMessage("Your payment was not successful, please try again.");
      //     break;
      //   default:
      //     showMessage("Something went wrong.");
      //     break;
      // }
    }

    // 检查 stripe 处理结果
    checkStatus();
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
  },
  data() {
    const _this = this;
    return {
      /**
       * 无论何种情况都跳转到激活页
       */
      overrideBackClick() {
        _this.$router.replace({ name: "ActivePage" });
      },
    };
  },
  methods: {
    /**
     * 登出按钮点击事件
     */
    async logoutClick() {
      await this.$confirm.show({
        title: this.$t("myPlanPage.logout"),
        text: `${this.$t("myPlanPage.logout")} ${this.user.email}?`,
      });
      this.$router.push({ name: "LoginApphiPage" });
      clear();
      window.location.reload();
    },
    /**
     * 点击跳转到升级页面
     */
    upgradeClick() {
      this.$router.push({
        name: "PaymentUpgradePage",
        params: { type: "all" },
      });
    },
    /**
     * 帮助按钮点击事件
     * @returns {Promise<void>}
     */
    async helpClick() {
      let currentPublisherName = "";
      // 获取当前Ins账号
      const currentPublisher = this.$store.getters[CURRENT_PUBLISHER_SIMPLE];
      // 先尝试获取选中publisher
      if (currentPublisher) {
        currentPublisherName = currentPublisher.username;
      } else if (this.user.linkedInstagramList.length > 0) {
        currentPublisherName = this.user.linkedInstagramList[0].username;
      }
      window.open(
        `https://mapiz.wufoo.com/forms/apphi-help/def/field3=${this.user.email}&field17=${currentPublisherName}`,
        "_blank"
      );
    },
  },
  async created() {
    try {
      await planList();
    } catch (e) {
      showErrorMsg(e);
    }
  },
};



// WEBPACK FOOTER //
// ./src/pages/my_plan/Index.vue